export default {
  student: {
    id: '',
    degreeId: '',
    curriculumId: '',
    facultyId: '',
    departmentId: '',
    code: '',
    prefixId: '',
    firstNameLocal: '',
    lastNameLocal: '',
    firstNameEng: '',
    lastNameEng: '',
    gender: '',
    telephone: '',
    email: '',
    picturePath: '',
    birthDate: '',
    citizenId: '',
    projectId: '',
    studentStatusId: '',
    examLocation: '',
    userId: '',
  },
  students: [],
  processing: false,
  error: null,
  success: null,
}



